import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from 'foundations-assets/icons/useIconSize';
import { StyledIcon } from 'foundations-assets/icons/StyledIcon';
import { getDataProps } from 'foundations-assets/icons/getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const DynamicFilterIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "DynamicFilter",
    children: isCanvas ? /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "m19.76 10.14-5.5 1.12a.25.25 0 0 1-.3-.2c-.01-.06 0-.12.02-.17l3.89-8.29c.06-.13 0-.29-.13-.36-.04-.02-.09-.03-.14-.02l-6.64.64c-.1.02-.19.09-.22.19L6.71 16.79c-.04.14.03.28.17.32.05.01.1.02.14 0l3.93-.88c.15-.03.29.07.32.21v.11L8.18 29.66c-.04.14.05.29.19.33.12.03.24-.02.3-.13l11.38-19.31c.1-.11.09-.27-.02-.36a.27.27 0 0 0-.26-.05Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "m17.81 8.81 1.54-.27 3.13-6.16c.06-.13 0-.29-.13-.36-.04-.02-.08-.03-.13-.02l-1.5.11-3.2 6.32c-.06.13 0 .29.13.36.05.02.1.03.15.02ZM24.95 9.18l-1.58.3-9.11 15.5-.87 3.69c-.02.15.08.28.22.31.1.02.2-.03.26-.11l11.4-19.31c.08-.13.04-.29-.09-.37a.29.29 0 0 0-.24-.02Z"
      })]
    }) : /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M14.59 31.86c-.1 0-.2-.01-.29-.04-.5-.13-.85-.59-.85-1.1V19.29H7.01a1.142 1.142 0 0 1-.99-1.71l5.25-9.13c.31-.55 1.01-.74 1.56-.42.55.31.74 1.01.42 1.56l-4.26 7.42h5.6c.63 0 1.14.51 1.14 1.14v8.29l6.75-11.72h-5.6c-.63 0-1.14-.51-1.14-1.14V1c0-.63.5-1.14 1.14-1.14.63 0 1.14.51 1.14 1.14v11.43h6.44a1.142 1.142 0 0 1 .99 1.71l-9.86 17.14c-.21.36-.59.57-.99.57Z"
      })
    })
  }));
};
DynamicFilterIcon.displayName = 'DynamicFilterIcon';